import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EventsPage } from '../../features/B3/events-page';
import { EVENT_FILTERS } from '../../features/B3/types';

const Id = z.string().regex(/^[A-Za-z0-9_-]{1,64}$/);

const searchSchema = z.object({
  status: z.enum(EVENT_FILTERS).optional().catch(undefined),
  siteId: Id.optional().catch(undefined),
  clientId: Id.optional().catch(undefined),
  open: Id.optional().catch(undefined),
});

/** #/events — NIVISION events log (lane B3-web). */
export const Route = createFileRoute('/_app/events')({
  validateSearch: (s: Record<string, unknown>) => searchSchema.parse(s),
  component: EventsRoute,
});

function EventsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <EventsPage search={search} onSearch={(next) => void navigate({ search: next, replace: true })} />;
}
